import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { PedidoService } from 'src/app/services/pedido.service';
import { NotificacaoService } from './../../services/notificacao.service';
import { CarregandoService } from './../../services/carregando.service';

@Component({
  selector: 'app-retorno-pagamento',
  templateUrl: './retorno-pagamento.component.html',
  styleUrls: ['./retorno-pagamento.component.scss']
})
export class RetornoPagamentoComponent implements OnInit {

  tipo = 0;
  idPedido;
  msg = '';
  corFundo = '';
  icone = '';
  idPagamento = '';

  constructor(private route: ActivatedRoute, private pedidoService: PedidoService, private router: Router,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService) { }

  ngOnInit() {
    this.idPedido = this.route.snapshot.paramMap.get('id');

    this.idPagamento = this.route.snapshot.queryParamMap.get('payment_id');

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];

      if ((this.idPagamento === null || this.idPagamento === undefined || this.idPagamento === '') && (this.tipo === 0 || this.tipo === 1)) {
        this.msg = 'Não foi possível realizar o pagamento...';
        this.corFundo = 'alert-danger';
        this.icone = 'error';
      } else {
        switch (this.tipo) {
          case 0:
            this.salvarFinanceiro();
            this.msg = 'Pagamento realizado com sucesso!!!';
            this.corFundo = 'alert-success';
            this.icone = 'check_circle';
            break;

          case 1:
            this.salvarFinanceiro();
            this.msg = 'Aguardando a efetivação do pagamento...';
            this.corFundo = 'alert-primary';
            this.icone = 'watch_later';
            break;

          case 2:
            this.msg = 'Não foi possível realizar o pagamento...';
            this.corFundo = 'alert-danger';
            this.icone = 'error';
            break;

          default:
            break;
        }
      }
    });
  }

  salvarFinanceiro() {
    // this.idPagamento = this.route.snapshot.queryParamMap.get('payment_id');
    this.carregandoService.mostra('salvarFinanceiro');

    this.pedidoService.salvarFinanceiroMercadoPago(this.idPedido, this.idPagamento).subscribe(resp => {
      this.carregandoService.esconde('salvarFinanceiro');

      this.router.navigate(['/pedidos']);

    }, (erro) => {
      this.msg = 'Não foi possível salvar os dados do Mercado Pago...';
      this.corFundo = 'alert-danger';
      this.icone = 'error';
      this.carregandoService.esconde('salvarFinanceiro');
      this.notificacaoService.erro(erro);
    });
  }

}
